import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TabsModule } from 'ngx-bootstrap';
import { FourDotFivePhoneNumberModule } from 'src/app/shared/four-dot-five-phone-number/four-dot-five-phone-number.module';
import { SendCandidateOutreachEmailModule } from 'src/app/shared/send-candidate-outreach-email/send-candidate-outreach-email.module';
import { CandidateFileUploadModule } from '../../candidates-page/candidate-file-upload/candidate-file-upload.module';
import { UploadResumesModule } from '../upload-resumes/upload-resumes.module';
import { UploadSingleResumeModule } from '../upload-single-resume/upload-single-resume.module';
import { BulkResumeUploadModule } from 'src/app/shared/bulk-resume-upload/bulk-resume-upload.module';
import { UnifiedResumeUploadModule } from '../unified-resume-upload/unified-resume-upload.module';
import { AddCandidatesComponent } from './add-candidates.component';

@NgModule({
  declarations: [AddCandidatesComponent],
  imports: [
    CommonModule,
    FormsModule,
    TabsModule.forRoot(),
    FourDotFivePhoneNumberModule,
    SendCandidateOutreachEmailModule,
    CandidateFileUploadModule,
    UploadResumesModule,
    UploadSingleResumeModule,
    BulkResumeUploadModule,
    UnifiedResumeUploadModule
  ],
  exports: [AddCandidatesComponent],
  entryComponents: [AddCandidatesComponent]
})
export class AddCandidatesModule { }
